import { render, staticRenderFns } from "./QPopupSubmenu.vue?vue&type=template&id=6a1f43ce&"
import script from "./QPopupSubmenu.vue?vue&type=script&lang=js&"
export * from "./QPopupSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports